import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  allProducts: any[] = [];
  allOrders: any[] = [];
  allInvoices_Lists: any[] = [];
  allDC_Lists: any[] = [];

  allCustomerAddresses: any[] = [];

  billingAddress: any[] = [];
  deliveryAddress: any[] = [];
  distinctPO_Nos: any[] = [];


  InvoiceData: any = {};
  displayBankInfo: any = {};
  LastInvoiceID: any = "";


  constructor(private http: HttpClient, public _config: ConfigService, public _router: Router, private toastr: ToastrService) { }

  //Get the API data

  doGET(url?: any, header?: any) {
    return this.http.get(url, header);
  }
  //POST the API data

  doPOST(url?: any, postBody?: any, header?: any) {
    return this.http.post(url, postBody, header);
  }

  //Update the API data
  doPUT(url?: any, postBody?: any, header?: any) {
    return this.http.put(url, postBody, header);
  }

  //Delete the API data
  doDELETE(url?: any, header?: any) {
    return this.http.delete(url, header)
  }

  commonheader() {
    let headerOption = new HttpHeaders(
      // {
      //   'Content-Type': 'application/json',
      //   'Auth-Key': 'sugu',
      //   'Client-Security-Token': 'sugu123',
      // }
    );

    let headerData = { headers: headerOption };

    return headerData;
  }


  redirectTo(page: any) {
    this._router.navigate([page]);
  }

  /**************** Toast Config *********************** */

  showSuccess(msg?: any) {
    this.toastr.success(msg, 'Success!');
  }


  showError(msg?: any) {
    this.toastr.error(msg, 'Error!');
  }



  isTokenExist() {
    return !!localStorage.getItem('token');
  }


  getToken() {
    return localStorage.getItem('token') || "";
  }


  /**************** Get List Config *********************** */

  getAllProducts() {

    let requestURL = this._config.baseURL + this._config.getAllProducts;
    let headerOption = this.commonheader();

    this.doGET(requestURL, headerOption).subscribe((results: any) => {
      debugger;
      this.allProducts = results.data || [];

      this.distinctPO_Nos = [];

      this.allProducts.forEach(element => {

        let indexVal = this.distinctPO_Nos.findIndex(obj => (obj.po_no == element.po_no));
        if (indexVal == -1)
          this.distinctPO_Nos.push(element);


      });
    });

  }



  getCustomers() {
    let requestURL = this._config.baseURL + this._config.getCustomer;
    let headerOption = this.commonheader();
    this.doGET(requestURL, headerOption).subscribe((results: any) => {
      this.allCustomerAddresses = results.data || [];

      this.billingAddress = this.allCustomerAddresses.filter(obj => obj.customer_type == "Billing");
      this.deliveryAddress = this.allCustomerAddresses.filter(obj => obj.customer_type == "Delivery");

    });

  }


  getAllBanks() {

    let requestURL = this._config.baseURL + this._config.getBank;
    let headerOption = this.commonheader();

    this.doGET(requestURL, headerOption).subscribe((results: any) => {
      let allBanks = results.data || [];

      this.displayBankInfo = allBanks ? allBanks[allBanks.length - 1] : {};
    });

  }


  getAllOrders() {

    let requestURL = this._config.baseURL + this._config.getAllOrders;
    let headerOption = this.commonheader();

    this.doGET(requestURL, headerOption).subscribe((results: any) => {
      this.allOrders = results.data || [];

      this.allInvoices_Lists = this.allOrders.filter(obj => obj.invoice_type == 'Invoice');
      this.allDC_Lists = this.allOrders.filter(obj => obj.invoice_type == 'DC');



    });

  }

  getLastOrderID() {

    let requestURL = this._config.baseURL + this._config.getLastOrderID;
    let headerOption = this.commonheader();

    this.doGET(requestURL, headerOption).subscribe((results: any) => {
      let LastInvoiceID = results.data || { id: 0 };

      let id = Number(LastInvoiceID.id) || 0;

      this.LastInvoiceID = '#SI0' + (id + 1) + ' / 26-27';

    });

  }




  getRupeesInWords(amount: any) {

    let requestURL = this._config.baseURL + this._config.getRupeesInWords;
    requestURL = requestURL.replace('{total}', amount);

    let headerOption = this.commonheader();

    this.doGET(requestURL, headerOption).subscribe((results: any) => {

      this.InvoiceData.totalObject.amount_in_rupees = results.data;

    });

  }






}
